import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalKhoa } from "./ModalKhoa";

export const BtnKhoa = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} onClick={handleShow}>
        <PopoversBootrap
          contentText="Khoá"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <i className="mdi mdi-lock"></i>
        </PopoversBootrap>
      </a>

      {show && (
        <ModalKhoa show={show} onHide={handleClose} Id={item.Id} item={item} />
      )}
    </>
  );
};
